import { TimelineSegmentDataBase, TimelineSegmentContentDataBase } from '../ScattData.js';

class NoteData extends TimelineSegmentContentDataBase {
  constructor(text = '', date = new Date()) {
    super();
    this.text = text;
    this.date = date;
  }

  static generateFromRawObj(noteDataRawObj) {
    return new this(noteDataRawObj['text'], new Date(noteDataRawObj['date']))
  }

  generateRawObj() {
    let noteDataRawObj = {};
    noteDataRawObj['text'] = this.text;
    noteDataRawObj['date'] = this.date.toISOString();
    return noteDataRawObj;
  }

  toString() {
    return this.text;
  }

  clone() {
    return new this.constructor(this.text, new Date(this.date.getTime()))
  }

  isSameAs(that) {
    if (this.text !== that.text) return false;
    if (this.date.getTime() !== that.date.getTime()) return false;
    return true;
  }
}

class NoteSegmentData extends TimelineSegmentDataBase {
  static contentData = NoteData;

  constructor(begin, end, noteData, isLocked) {
    super(begin, end, noteData, isLocked);
  }

  static toString() {
    return 'NoteSegmentData';
  }

  static get name() {
    return 'Note Data';
  }

  clone() {
    return super.clone(false);
  }
}

export default NoteSegmentData;
